import React, { MouseEventHandler } from 'react'
import styles from './Button.module.scss'

export interface ButtonProps {
    type?: 'button' | 'submit' | 'reset' | undefined
    disabled?: boolean
    href?: string
    onClick?: MouseEventHandler
    children?: React.ReactNode
    className?: string
    buttonStyle?: string
}

const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
    const { type, href, onClick, children, className, disabled, buttonStyle } = props

    const classes =
        styles.Button + ' ' + (buttonStyle ? styles[buttonStyle] : styles.default) + ' ' + (className ? className : '')

    const markup = href ? (
        <a className={classes} href={href}>
            {children}
        </a>
    ) : (
        <button className={classes} disabled={disabled} onClick={onClick} type={type || 'button'}>
            {children}
        </button>
    )

    return markup
}

export default Button
